import {Button, Card, CardContent, Typography} from '@mui/material';
import {formatDistanceToNow, parse} from 'date-fns';
import {ptBR} from 'date-fns/locale';
import React, {Fragment, useState} from 'react';

import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {translations} from 'presentation/translations-new';
import {getGracePeriod} from 'presentation/utils';
import {GracePeriodDetailsModal} from '../GracePeriodDetailsModal';
import {StyledCardActions} from './styles';
import {GracePeriodCardProps} from './types';

const {showDetails, endsIn} = translations['pt-br'].commons;

export function GracePeriodCard({planType}: GracePeriodCardProps) {
	const {
		beneficiary: {dtCarenciaC, dtCarenciaOdontoC},
	} = useAccountDataStore(store => store.accountData);
	const isOdonto = planType === 'odonto';
	const formattedEndsIn = `${endsIn} ${isOdonto ? dtCarenciaOdontoC : dtCarenciaC}`;
	const distancetoNow = formatDistanceToNow(
		parse(isOdonto ? dtCarenciaOdontoC : dtCarenciaC, 'P', new Date(), {locale: ptBR}),
		{
			locale: ptBR,
		},
	);
	const formattedDateDue = getGracePeriod(distancetoNow);

	const [open, setOpen] = useState(false);

	function handleShowDetails() {
		setOpen(true);
	}

	return (
		<Fragment>
			<Card elevation={0}>
				<CardContent>
					<Typography variant="h6" color="primary">
						{formattedDateDue}
					</Typography>
					<Typography fontSize={14} color="text.secondary">
						{formattedEndsIn}
					</Typography>
				</CardContent>
				<StyledCardActions>
					<Button onClick={handleShowDetails} variant="text">
						{showDetails}
					</Button>
				</StyledCardActions>
			</Card>
			<GracePeriodDetailsModal
				endsIn={formattedEndsIn}
				dateDue={formattedDateDue}
				open={open}
				setOpen={setOpen}
			/>
		</Fragment>
	);
}
